import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import NoFileSelectedIcon from '@/assets/icons/no_file_selected.svg?react';
import { FileUploadStatusMessage } from './FileUploadStatusMessage';
import { FileUploadStatusMessageWrapper } from './FileUploadStatusMessageWrapper';

export const NoFileSelected: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <NoFileSelectedIcon className='size-10' />

      <FileUploadStatusMessageWrapper>
        <FileUploadStatusMessage message={t('data_source_edit:file.progress_bar.no_file_selected')} />
      </FileUploadStatusMessageWrapper>
    </>
  );
};
